import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

  // Redirect empty path to '/example'
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

  // Redirect signed-in user to the '/example'
  //
  // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
  // path. Below is another redirection for that path to redirect the user to the desired
  // location. This is a small convenience to keep all main routes together here on this file.
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

  // Auth routes for guests
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
      { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
      { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
      { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
      { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') }
    ]
  },

  // Auth routes for authenticated users
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
      { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') }
    ]
  },

  // Landing routes
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      { path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes') },
    ]
  },

  // Admin routes
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver
    },
    children: [
      { path: 'dashboard', loadChildren: () => import('app/modules/admin/example/example.routes') },
      { path: 'bins', loadChildren: () => import('app/modules/admin/bin-locations/bin-locations.routes') },
      { path: 'picklists', loadChildren: () => import('app/modules/admin/picklists/picklists.routes') },
      { path: 'products', loadChildren: () => import('app/modules/admin/products/products.routes') },
      { path: 'orders', loadChildren: () => import('app/modules/admin/orders/orders.routes') },
      { path: 'warehouses', loadChildren: () => import('app/modules/admin/warehouses/warehouses.routes') },
      { path: 'arrangement', loadChildren: () => import('app/modules/admin/arrangement/arrangement.routes') },
      { path: 'reposition', loadChildren: () => import('app/modules/admin/reposition/reposition.routes') },
      { path: 'picking-transfers', loadChildren: () => import('app/modules/admin/picking-transfers/picking-transfers.routes') },
      { path: 'manual-import', loadChildren: () => import('@modules/admin/manual-import/manual-import.routes') },
      { path: 'users', loadChildren: () => import('app/modules/admin/users/users.routes') },
      { path: 'settings', loadChildren: () => import('app/modules/admin/settings/settings.routes') },
    ]
  }
];
